module.exports = __webpack_public_path__ + "static/media/bi_symbol_image_white_m.4d0102be.png";